import PropTypes from 'prop-types';
import Spinner from 'Components/Atoms/Spinner';
import { cn } from 'Utils/cn';
import OutlineArrowRight from 'Components/Atoms/OutlineIcons/OutlineArrowRight';

export default function ItemSelector(props) {
    const {
        onClick,
        image,
        title,
        description = '',
        className,
        classes = {},
        icon,
        isBusy,
        customImage,
        ellipsis,
        badge,
    } = props;
    return (
        <button
            type="button"
            disabled={isBusy}
            className={cn(
                'group text-left inline-flex items-center justify-center rounded-lg focus-visible:outline-none focus-visible:ring-2 disabled:pointer-events-none disabled:opacity-75 ring-primary/20 focus-visible:border-primary transition-all relative bg-white border border-gray-200 shadow-sm hover:bg-gray-50 text-dark-blue',
                'py-3.5 px-4 w-full gap-3 justify-between min-w-0',
                className,
            )}
            onClick={onClick}
        >
            <div className={cn('flex items-center gap-3 min-w-0')}>
                {customImage
                    ? customImage
                    : image && (
                          <img
                              src={image}
                              width={50}
                              height={50}
                              alt=""
                              className={cn('size-10 rounded-lg object-contain', classes.image)}
                          />
                      )}
                <div className={cn('flex flex-col min-w-0')}>
                    <div className={cn('flex items-center min-w-0 gap-2')}>
                        <div className={cn('text-base font-semibold truncate', classes.title, ellipsis)}>{title}</div>
                        {badge}
                    </div>
                    <div className={cn('opacity-50 mt-1 text-sm', classes.description)}>{description}</div>
                </div>
            </div>
            {isBusy ? (
                <div className={classes.loading}>
                    <Spinner size={32} color="rgba(32,32,32, .5)" />
                </div>
            ) : (
                <div className="shrink-0 pl-6">
                    {icon ? (
                        icon
                    ) : (
                        <div className="transition-transform duration-200 ease-in-out group-hover:translate-x-1">
                            <OutlineArrowRight size={20} className="text-dark-blue" />
                        </div>
                    )}
                </div>
            )}
        </button>
    );
}

ItemSelector.propTypes = {
    onClick: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    image: PropTypes.string,
    description: PropTypes.string,
    className: PropTypes.string,
    classes: PropTypes.object,
    icon: PropTypes.node,
    isBusy: PropTypes.bool,
    customImage: PropTypes.node,
    ellipsis: PropTypes.bool,
    badge: PropTypes.node,
};
